module.exports = __webpack_public_path__ + "static/img/decor-left.cefd57c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sack/decor-left.png
// module id = bPvf
// module chunks = 1